import React, { useEffect, useState } from 'react';

import CodeBlockV2 from '../CodeBlockV2';
import {
  createCurlSampleCode,
  createNodeSampleCode,
  createRubySampleCode,
} from './simpleLangConverter';
import { createPythonSampleCode } from './pythonConverter';
import { createJavaSampleCode } from './javaConverter';
import { createGoSampleCode } from './goConverter';
import { createFernGoSampleCode } from './fernGoConverter';
import Select from '../../Inputs/Select/Select';
import { useTrack } from 'src/contexts/AnalyticsContext';
import { LINK_TOKEN_CREATE_EVENTS } from 'src/lib/trackingEvents';

export interface ltcUseCase {
  useCase: string;
  config: Record<string, unknown>;
  comment?: string;
}

export interface Props {
  useCases: Array<ltcUseCase>;
  filenameAsTitle?: boolean;
}

const LinkTokenCreate: React.FC<Props> = (props: Props) => {
  const track = useTrack();

  const [selectedIndex, setSelectedIndex] = useState('0');
  const sample = props.useCases[Number(selectedIndex)] ?? props.useCases[0];
  const sampleLTCObject = sample?.config ?? {};
  const sampleComment = sample?.comment ?? '';

  useEffect(() => {
    track({
      type: LINK_TOKEN_CREATE_EVENTS.SELECTOR_LOADED,
    });
  }, []);

  // Do I need to call this directly, or could I make this a userEffect
  const trackSelectedUseCase = (index: string) => {
    track({
      type: LINK_TOKEN_CREATE_EVENTS.OPTION_PICKED,
      payload: {
        useCase: props.useCases[parseInt(index)].useCase,
      },
    });
  };

  return (
    <>
      {props.useCases.length > 1 && (
        <Select
          id='configObject'
          label='Select a sample scenario / product'
          name='ltcSelect'
          onChange={(e) => {
            trackSelectedUseCase(e.value);
            setSelectedIndex(e.value);
          }}
          options={
            props.useCases != null &&
            props.useCases.map((obj, idx) => {
              return {
                label: obj.useCase,
                value: idx,
              };
            })
          }
        />
      )}
      <CodeBlockV2
        type={'server'}
        fernGoCode={createFernGoSampleCode(sampleLTCObject, sampleComment)}
        variants={{
          node: createNodeSampleCode(sampleLTCObject, sampleComment),
          python: createPythonSampleCode(sampleLTCObject, sampleComment),
          bash: createCurlSampleCode(sampleLTCObject, sampleComment),
          ruby: createRubySampleCode(sampleLTCObject, sampleComment),
          java: createJavaSampleCode(sampleLTCObject, sampleComment),
          go: createGoSampleCode(sampleLTCObject, sampleComment),
        }}
        title={props.filenameAsTitle ? 'server.js' : '/link/token/create'}
      />
    </>
  );
};

LinkTokenCreate.displayName = 'LinkTokenCreate';
export default LinkTokenCreate;
